import React from "react";
import { Link } from "react-router-dom";

class IKIT extends React.Component {
  componentDidMount() {
    document.title =
      "IKIT 2021 - 5th International Workshop on Information and Knowledge in Internet of Things";
  }

  render() {
    return (
      <div>
        <div className="intro">
          <div className="container">
            <div className="row">
              <div className="col-lg-9">
                <div className="col text-center">
                  <div className="section_title_container text-center">
                    <div className="contact_title">
                      <h3 style={{ textAlign: "left" }}>
                        6th International Workshop on Information and Knowledge
                        in Internet of Things
                      </h3>
                    </div>
                  </div>
                  <div className="intro_left_content text_left">
                    <p align="left">
                      The International Workshop on Information and Knowledge in
                      the Internet of Things (IKIT 2026) in conjunction with the
                      15th International Conference on Information Technology
                      and Applications (ICITA 2026), will be held in Sydney, UAE
                      on 13 - 14 July 2026.
                    </p>
                    <p align="left">
                      Internet of Things (IoT) is currently one of the most
                      challenging areas of the Internet, enabling communication
                      and ubiquitous computing between global citizens,
                      networked machines and physical objects, providing a
                      promising vision of the future integrating the real world
                      of knowledge agents and things with the virtual world of
                      information. IoT is seen as a network of trillions of
                      agents and machines that communicate with each other,
                      being a profound technological revolution, which is the
                      current reality and the future of computing and
                      communications, supported by a dynamical technological
                      evolution in many fields, from wireless sensors, wireless
                      sensor networks, to nanotechnology. Due to its broad
                      impact in many fields, it has rapidly gained global
                      attention from academia, governments, industry and
                      citizenship. This change in the network of agency
                      profoundly modifies the landscape of human activity,
                      particularly as regards knowledge acquisition and
                      production, offering new possibilities but also challenges
                      that need to be explored and assessed.
                    </p>
                    <p align="left">
                      This workshop explores the information and knowledge in
                      the IoT, in particular investigate data management and
                      processing, information extraction, technology, knowledge
                      management, knowledge sharing, knowledge co-creation,
                      knowledge integration, and the development of new
                      intelligent services available anytime, anywhere, by
                      anyone and anything.
                    </p>
                    <br></br>
                    <div align="left">
                      <div>
                        <h4>Previous Workshop Editions</h4>
                      </div>
                      <p align="left">
                        The fourth edition of the Workshop on Information and
                        Knowledge in the Internet of Things(IKIT 2020), was
                        realized in conjunction with the International
                        Conference on Information Technology & Systems. ICITS
                        2020. 5-7 January, Bogotá, Colombia
                      </p>
                      <p align="left">
                        The third edition of the Workshop on Information and
                        Knowledge in the Internet of Things (IKIT 2019), was
                        realized in conjunction with the International
                        Conference on Applied Informatics. ICAI 2019
                        (http://icai.itiud.org/2019/index.php?pid=acceptedWorkshops),
                        6 to 9 November 2019, Madrid, Spain
                      </p>
                      <p align="left">
                        The second International Workshop on Information and
                        Knowledge in the Internet of Things (IKIT 2018), was
                        realized in conjunction with The 6th International
                        Conference on Future Internet of Things and Cloud.
                        FiCloud 2018 (http://www.ficloud.org/2018/), 6-8 August
                        2018, Barcelona, Spain.
                      </p>
                      <p align="left">
                        The first International Workshop on Information and
                        Knowledge in the Internet of Things (IKIT 2017), was
                        realized in conjunction with The 5th International
                        Conference on Future Internet of Things and Cloud.
                        FiCloud 2017 (http://www.ficloud.org/2017/), 21-23
                        August 2017, Prague, Czech Republic.
                      </p>
                    </div>
                    <br></br>
                    <div align="left">
                      <div>
                        <h4>Call for papers</h4>
                      </div>
                      <p align="left">
                        We invite researchers and practitioners to report on
                        up-to-date innovation and development, summarize the
                        state of the art, ideas and advances in all aspects of
                        systems, information and knowledge in the IoT and the
                        new landscape of networking possibilities. Prospective
                        authors are encouraged to submit papers for evaluation
                        by the Scientific Committee. The papers must be written
                        in English. All papers will be subjected to a
                        “double-blind review” by at least two members of the
                        Scientific Committee, on the basis of relevance,
                        originality, importance and clarity. Submitted papers
                        should be related with one or more of the main topics of
                        interest proposed for the Workshop
                      </p>
                    </div>
                    <br></br>
                    <div align="left">
                      <div>
                        <h4>Topics of Interest</h4>
                      </div>
                      <ul style={{ listStyleType: "circle" }} align="left">
                        <li>Assistive Technology </li>
                        <li>Augmented Cognition</li>
                        <li>Context Aware Systems and Applications</li>
                        <li>Data Management in IoT</li>
                        <li>Decision Support Systems in IoT</li>
                        <li>
                          e-Participation, e-Government, e-Hybrid Services
                        </li>
                        <li>IoT-enabled computing paradigms</li>
                        <li>IoT in Education</li>
                        <li>IoT Knowledge Network</li>
                        <li>IoT Sensing Things Technology and Applications</li>
                        <li>Knowledge Management</li>
                        <li>Knowledge Networks</li>
                        <li>Knowledge Systems in IoT</li>
                        <li>Machine learning in IoT</li>
                        <li>Mobile and Cloud Computing in Pervasive Systems</li>
                        <li>Pervasive Systems Based on Cloud Computing</li>
                        <li>Security, Trust, and Privacy Issues in IoT</li>
                      </ul>
                      <br />

                      <h4> Organising Committee </h4>
                      <div>
                        The following types of papers can be submitted:
                        <ul style={{ listStyleType: "circle" }} align="left">
                          <li>
                            Teresa Guarda, Universidad Estatal Peninsula de
                            Santa Elena, Ecuador
                          </li>
                          <li>
                            Filipe Portela, Algoritmi Research Centre, Portugal
                          </li>
                          <li>
                            Maria Fernanda Augusto, BITrum-Research Group, Spain
                          </li>
                        </ul>
                      </div>
                      <h4> Program Committee </h4>
                      <ul style={{ listStyleType: "circle" }} align="left">
                        <li>
                          Abbas Fadhil Aljuboori, University of Information
                          Technology and Communications, Iraq
                        </li>
                        <li>
                          Arlindo Veiga, Universidade de Cabo Verde, Cabo Verde
                        </li>
                        <li>
                          Atallah Al-Shatnawi, Al-albayt University, Jordan
                        </li>
                        <li>
                          Carlos Balsa, Instituto Politécnico de Bragança,
                          Portugal Christoph
                        </li>
                        <li>
                          Schütz, Johannes Kepler University Linz, Austria
                        </li>
                        <li>Claudia Abbas, University of Brasilia, Brazil</li>
                        <li>
                          Cristian López Raventós, Universidade Nacional
                          Autónoma do México - UNAM, México
                        </li>
                        <li>
                          Cristina Alcaraz, Universidad de Malaga, Spain Daniele
                          Riboni,University of Cagliari, Italy
                        </li>
                        <li>
                          Diana Lancheros-Cuesta, Universidad de la Salle,
                          Colombia
                        </li>
                        <li>
                          Eugen Rusu, Dunarea de Jos University of Galati,
                          Romania
                        </li>
                        <li>
                          Felipe Torres Leite, Universidade do Estado do Rio
                          Grande do Norte - UERN, Brazil
                        </li>
                        <li>
                          Filipe Mota Pinto, Instituto Politécnico de Leiria,
                          Portugal
                        </li>
                        <li>Francisco Salto, BITrum-Research Group, Spain</li>
                        <li>
                          Geovanni Ninahualpa, Universidad de las Fuerzas
                          Armadas - ESPE, Ecuador
                        </li>
                        <li>
                          Giovana Garrido, Universidad Tecnologica de Panama,
                          Panama
                        </li>
                        <li>
                          Govardhan Aliseri, Jawaharlal Nehru Technological
                          University Hyderabad, India
                        </li>
                        <li>
                          Härer Felix, Digitalization and Information Systems
                          Group, University of Fribourg, Switzerland
                        </li>
                        <li>
                          Hernan Nina Hanco, Universidad Nacional de San Antonio
                          Abad del Cusco, Perú
                        </li>
                        <li>
                          Hugo Peixoto, University of Minho, Portugal Inna
                        </li>
                        <li>
                          Skarga-Bandurova, East Ukrainian National University,
                          Ukraine
                        </li>
                        <li>
                          Isabel Lopes, Instituto Politécnico de Bragança,
                          Portugal
                        </li>
                        <li>
                          Javier Pereira, Universidad Tecnologica de Chile,
                          Chile
                        </li>
                        <li>
                          João Paulo Teixeira, Polytechnic Institute of
                          Bragança, Portugal
                        </li>
                        <li>
                          Jorge Bacca, Fundacion Universitaria Konrad Lorenz,
                          Colombia
                        </li>
                        <li>José L. Barros J., University of Vigo, Spain</li>
                        <li>
                          Kalinka Kaloyanova, University of Sofia, Bulgaria
                        </li>
                        <li>
                          Kamlesh Dutta,National Institute of Technology
                          Hamirpur, India
                        </li>
                        <li>Luca Anselma, Università di Torino, Italy</li>
                        <li>
                          Luis Garcia Santander, Universidad de Concepcion,
                          Chile
                        </li>
                        <li>
                          Manuela Cañizares , UDIMA-Universidad a Distancia de
                          Madrid, Spain
                        </li>
                        <li>
                          Maria Ribeiro, Instituto Politécnico Bragança,
                          Portugal
                        </li>
                        <li>
                          Mark Burgin, University of California, Los Angeles,
                          USA
                        </li>
                        <li>
                          Mohammad Shahadat Hossain, University of Chittagong,
                          Bangladesh
                        </li>
                        <li>
                          Neelam Gohar, Shaheed Benazir Bhutto Women University
                          Peshawar, Pakistan
                        </li>
                        <li>
                          Nervo Verdezoto, Cardiff University, United Kingdom
                        </li>
                        <li>
                          Nishu Gupta,Vaagdevi College of Engineering, India
                        </li>
                        <li>
                          Rafael Timóteo De Sousa Júnior, University of Brasilia
                          - UnB, Brazil
                        </li>
                        <li>Ran Wei, Dalian University of Technology, China</li>
                        <li>
                          Rytis Maskeliunas, Kaunas University of Technology,
                          Lithuania
                        </li>
                        <li>
                          Sergio Costa, Universidade Federal do Maranhão, Brazil
                        </li>
                        <li>
                          Sílvia Ferrão, Macao Polytechnic Institute, Macao
                        </li>
                        <li>
                          Simone Belli, Universidad Complutense de Madrid ,
                          Spain
                        </li>
                        <li>
                          Wagner Tanaka Botelho, Federal University of ABC,
                          Brazil
                        </li>
                        <li>
                          Wolfgang Hofkirchner, Institute for a Global
                          Sustainable Information Society, Austria
                        </li>
                        <li>
                          Zdzislaw Polkowski, Jan Wyzykowski University, Poland
                        </li>
                      </ul>

                      <h4> Publication and Indexing </h4>

                      <p>
                        Published Full and Short papers will be submitted for
                        indexation by <b>ISI</b>, <b>SCOPUS</b>, and{" "}
                        <b>Google Scholar</b>, among others, and will be
                        available in the <b>SpringerLink Digital Library.</b>
                      </p>
                      <h4> Registration Fee (0$)</h4>
                      <p>
                        The event is organised in a hybrid mode and the
                        registration fee has been waived off. All accepted
                        papers will be published free of cost in the conference
                        proceedings.
                      </p>
                      <h4>Important Dates</h4>
                      <p>
                        <Link to="/Importantdates">
                          Click here for important dates
                        </Link>
                      </p>
                      <h4> Submissions</h4>
                      <p>
                        <p align="left">
                          Submitted papers for review must comply with the
                          format of Lecture Notes in Network Systems Series (see
                          Instructions for Authors at{" "}
                          <a
                            href="https://www.springer.com/de/authors-editors/book-authors-editors/resources-guidelines/book-manuscript-guidelines/manuscript-preparation/5636"
                            target="_blank"
                          >
                            Springer Website
                          </a>
                          ), be written in English, must not have been published
                          before, not be under review for any other conference
                          or publication and not include any information leading
                          to the authors’ identification. Therefore, the
                          authors’ names, affiliations and bibliographic
                          references should not be included in the version for
                          evaluation by the Program Committee. This information
                          should only be included in the camera-ready version,
                          saved in Word or Latex format and also in PDF format.
                          These files must be accompanied by the filled 'Consent
                          to Publish' form. All files need to compressed e.g., (
                          a ZIP file), and uploaded at the conference management
                          system.
                        </p>
                        <p>
                          All papers will be subjected to a “double-blind
                          review” by at least three members of the Program
                          Committee.
                        </p>
                        <p>
                          Based on Program Committee evaluation, a paper can be
                          rejected or accepted by the Conference Chairs. In the
                          later case, it can be accepted as the type originally
                          submitted or as another type. Thus, full papers can be
                          accepted as short papers or poster papers only.
                          Similarly, short papers can be accepted as poster
                          papers only.
                        </p>
                      </p>

                      {/* <div className="button button_2 intro_button">
                        <a href="https://easychair.org/cfp/IKIT2021">
                          <span>
                            Submissions{" "}
                            <img src={require("../assets/arrow.png")} alt="" />
                          </span>
                        </a>
                      </div> */}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-3 sidebar_col">
                <div className="sidebar">
                  <br></br>
                  <p>
                    {" "}
                    <img
                      src={require("../assets/springerlink.jpg")}
                      width="230"
                      height="auto"
                    />{" "}
                  </p>
                  <div className="categories sidebar_list">
                    <div className="sidebar_title">Proceedings</div>
                    <ul>
                      <li>
                        <a
                          href="https://www.springer.com/series/15179"
                          target="_blank"
                        >
                          Lecture Notes in Network Systems Series
                        </a>
                        <a
                          href="https://www.springer.com/series/15179"
                          target="_blank"
                        >
                          <img
                            src={require("../assets/lnns.PNG")}
                            width="230"
                            height="340"
                          />
                        </a>
                      </li>
                    </ul>
                  </div>
                  <div className="categories sidebar_list">
                    <img
                      src={require("../assets/scopus.png")}
                      width="230"
                      height="auto"
                    />
                  </div>
                  <br></br>
                  <div className="categories sidebar_list">
                    <img
                      src={require("../assets/isi.jpg")}
                      width="230"
                      height="auto"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default IKIT;
